export default __webpack_public_path__ + "static/media/user.eab8fc7a.svg";